var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "control" }, [
    _c(
      "div",
      { staticClass: "form-group input-group alphabet-control" },
      [
        _vm._l(_vm.alpha, function(char) {
          return _c(
            "button",
            {
              key: char,
              staticClass: "btn-alpha notranslate",
              class: char == _vm.query ? "selected" : "",
              attrs: { disabled: _vm.isDisabled(char) },
              on: {
                click: function($event) {
                  return _vm.selectCharacter(char)
                }
              }
            },
            [_vm._v("\n\t\t\t" + _vm._s(char) + "\n\t\t")]
          )
        }),
        _vm._v(" "),
        _vm.query && _vm.query != ""
          ? _c(
              "button",
              {
                staticClass: "btn-clear",
                on: {
                  click: function($event) {
                    return _vm.clearSearch()
                  }
                }
              },
              [_vm._v("\n\t\t\tClear\n\t\t")]
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }